import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // 引入 router 配置文件




const app = createApp(App);
app.use(router); // 注册 Vue Router
app.mount('#app')


